import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface PaginationButtonProps {
  variant?: "previous" | "next" | "first" | "last" | "page";
  onClick: () => void;
  disabled?: boolean;
  active?: boolean;
  children?: React.ReactNode;
}

export function PaginationButton({
  variant = "page",
  onClick,
  disabled = false,
  active = false,
  children,
}: PaginationButtonProps) {
  const getIcon = () => {
    switch (variant) {
      case "previous":
        return <ChevronLeft className="size-4" />;
      case "next":
        return <ChevronRight className="size-4" />;
      case "first":
        return <ChevronsLeft className="size-4" />;
      case "last":
        return <ChevronsRight className="size-4" />;
      case "page":
        return children;
    }
  };

  return (
    <Button
      variant={active ? "default" : "outline"}
      size="sm"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "h-8 min-w-8",
        variant === "page" && "px-3",
        active && "pointer-events-none"
      )}
    >
      {getIcon()}
    </Button>
  );
}
